<template>
  <CmTabs
    v-model="activeTab"
    :tabs="tabs"
    type="2"
    :class="['section-statistics', `section-statistics--${type}`, `section-statistics--${activeTab}`]"
  >
    <div v-if="availableSteps" :slot="tabs[0]" class="section-statistics__tab-inner">
      <TotalBlocks :availableSteps="availableSteps" />
      <StatisticsFiltration v-if="activeTab === 0"/>
      <StatisticsTable :availableSteps="availableSteps" />
    </div>

    <CommunicationStat
      :slot="tabs[1]"
    />
  </CmTabs>
</template>

<script>
import CmTabs from "@/components/library/CmTabs.vue";
import TotalBlocks from "@/components/statistics/tables/TotalBlocks.vue";
import StatisticsTable from "@/components/statistics/tables/StatisticsTable.vue";
import CommunicationStat from "@/components/statistics/stats/CommunicationStat.vue";
import StatisticsFiltration from "@/components/statistics/general/Filtration.vue";

import { mapState } from "vuex";
import axios from "axios";

export default {
  name: "StatAndAudit",

  components: {
    CmTabs,
    StatisticsTable,
    CommunicationStat,
    StatisticsFiltration,
    TotalBlocks
  },

  data() {
    return {
      activeTab: 0,
      availableSteps: null
    }
  },

  created() {
    this.$store.commit("setStatActiveType", this.$route.params.type);
    this.getAvailableSteps();
  },

  computed: {
    ...mapState({
      type: state => state.stat.activeType
    }),
    tabs() {
      return ["Рассылки", ...(this.type !== 'whatsapp' ? ["статистика за период"] : [])];
    }
  },

  methods: {
    async getAvailableSteps() {
      const res = await axios.get(
        `/config/statisticsSteps.json?nocache=${new Date().getTime()}`
      );
      const steps = res.data[`${this.$store.state.user.company}`] || [
        "email",
        "sms",
        "viber",
        "push",
        "notification",
        "wallet",
        "webpush",
        "inapp",
        "webhook",
        "whatsapp",
        "chatbot",
      ];

      this.availableSteps = ["promotions", ...steps];
    }
  }
}
</script>

<style lang="scss">
@import "@/scss/stat/mainPage.scss";

.section-statistics {
  width: 100%;
  height: 100%;
  overflow-x: auto;

  & > .cm-tabs-header {
    margin: 10px 0 15px;
    align-items: center;
  }

  .cm-grouped-bar {
    @media screen and (max-width: 1476px) {
      margin-bottom: $gutter;
    }
  }

  .date-filter-label {
    margin-right: 20px;

    @media screen and (max-width: 1100px) {
      display: none;
    }
  }

  .cm-tabs--2 {
    & > .cm-tabs-header {
      margin-bottom: 25px;
      align-items: center;
    }
  }

  &__tab {
    padding-bottom: 40px;
    .cm-title {
      line-height: 28px;
      margin: 20px 0;
    }
  }

  &__row {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    transition: flex-direction 0.3s ease;
    margin-bottom: 15px;
    &--long-table-mode {
      justify-content: flex-end;
      margin-bottom: 0;
      .cm-state-card--grouped-bar {
        margin-right: 1px;
        margin-top: 15px;
      }
    }
  }

  &__tab-inner {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 $regular-space;
    min-height: 746px;
  }
}
</style>
